'use strict';
import dialog from '../dialog.js';
import modal from '../modal.js';

/*exports.init = function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
};*/
/*var dialog = require('../dialog'),
modal = require('../modal').global;*/

export default {
    init: function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        modal.global.addCustomClass('modal_store-locator');
        modal.global.renderByUrl($(e.target).attr('href'));
    });
    $(document).on('click', '.close-button', function(e) {
        e.preventDefault();
        dialog.close();
    });
}
}

/*$("#boutique-parent").click(function() {
    $('html, body').animate({
        scrollTop: $("#boutique-services-block").offset().top - 120
    }, 1000);
});*/

/*$("#boutique-girls-night-out").click(function() {
    $('html, body').animate({
        scrollTop: $("#boutique-store-events").offset().top - 120
    }, 1000);
});*/
